/**
 * CR-9081: the Quality / Delivery / Cost frame and cell for Current Performance.
 *
 * Thin wrappers over the Scheduled Dashboard's ``SectionFrame`` / ``KPICell``:
 *  - the frame takes no ``subtitle`` — the top-right note ("1st → today",
 *    "PO lines due this month", …) is gone from every Current Performance card;
 *  - every cell's value slot is the height of the 80px OTIF/OTD rings, so the
 *    labels, figures and captions of all three cards sit on the same lines.
 */
import { KPICell as BaseKPICell, SectionFrame as BaseSectionFrame, type KPICellProps } from '../scheduled/shared';

/** Height of the value slot — the ``size`` of the Delivery rings. */
export const PERF_VALUE_SLOT = 'h-20';

/** Headline-figure classes: whole numbers, and money (one step smaller so a
 *  seven-figure amount still fits a third of a card). */
export const PERF_NUMBER_CLASS = 'text-2xl font-semibold tabular-nums';
export const PERF_MONEY_CLASS = 'text-xl font-semibold tabular-nums whitespace-nowrap';

export function KPICell(props: Omit<KPICellProps, 'valueClassName'>) {
  return <BaseKPICell {...props} valueClassName={PERF_VALUE_SLOT} />;
}

export function SectionFrame({ title, accent, children }: {
  title: string;
  accent: 'red' | 'green' | 'blue';
  children: React.ReactNode;
}) {
  return <BaseSectionFrame title={title} accent={accent}>{children}</BaseSectionFrame>;
}

/** Caption under the PPM / PPK figure (CR-9081: the word, not "rej"). */
export function rejectedFoot(rejectQty: number): string {
  return `${rejectQty.toLocaleString()} Rejected`;
}
